/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import { loginUser } from '@/api/auth'
import { fetchData, deleteData } from '@/api/module'

import VueCookie from 'vue-cookie'

const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth ({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage ({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay ({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme ({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  //updateUserInfo ({ commit }, payload) {
  //  commit('UPDATE_USER_INFO', payload)
  //},

  async login ({commit}, userData) {
    const response  = await loginUser('login', userData)
    commit('setToken', response.data.data.token)
    commit('setUserInfo', response.data.data.userInfo)

    VueCookie.set('token', response.data.data.token, 1)
    VueCookie.set('userInfo', JSON.stringify(response.data.data.userInfo), 1)
    
    return response
  },

  async logout ({commit}) {

    commit('clearToken')
    commit('clearUserInfo')

    VueCookie.delete('token')
    VueCookie.delete('userInfo')

    //localStorage.removeItem('userInfo')
  },

  async loadCartItems ({ commit }, payload) {
    const { data }  = await fetchData(`order/${payload}/basket`)
    const cartItems = data.list
    commit('SET_CART_ITEMS', cartItems)
  },

  async deleteItemInCart ({ commit }, payload) {
    console.log(`actions deleteItemInCart: ${JSON.stringify(payload)}`)
    const orderBasketSeq = payload.orderBasketSeq
    const orderBasketItemSeq = payload.orderBasketItemSeq

    await deleteData(`order/${orderBasketSeq}/basket/${orderBasketItemSeq}`)
  },

  async setContentsParams ({ commit }, payload) {
    commit('setContentsParams', payload)
  },

  async setStudentParams ({ commit }, payload) {
    commit('setStudentParams', payload)
  },

  async setTeacherParams ({ commit }, payload) {
    commit('setTeacherParams', payload)
  },

  async setOrderSheetParams ({ commit }, payload) {
    commit('setOrderSheetParams', payload)
  },

  async setInstituteParams ({ commit }, payload) {
    commit('setInstituteParams', payload)
  },

  async setCommonMemberParams ({ commit }, payload) {
    commit('setCommonMemberParams', payload)
  }
  
}

export default actions
